import { View } from "binder"
import { DateTimeViewModel, defaultValueSelector } from "./dateTime-viewModel"

export class DateTimeView extends View<DateTimeViewModel>{
    GetViewUniqueId(): string {
        return "V-223DA586-7BAB-481C-8963-5A1C7B82FE0D"
    }
    loadHtml(): string {
        let element = require('./dateTime.html').default;
        let style = require('./dateTime.less');
        return element;
    }
    constructor() {
       super();
    }
    public set combo(v: defaultValueSelector) { this._combo = v; } public get combo(): defaultValueSelector { return this._combo;} private _combo: defaultValueSelector;
}
